import React from 'react'
import { useForm } from 'react-hook-form'
import Helmet from 'react-helmet'

import './style.css'

/* global API */

const LoginRoute = props => {
    const { register, handleSubmit } = useForm({
        mode: 'onSubmit',
    })

    const onSubmit = async (values) => {
        const data = await API.instance().generateToken(values.telegram.replace('@', ''), values.password)
        API.instance().setToken(data.token)
        props.handleUpdate(data.token)
    }

    return (
        <div className="page auth-page">
            <Helmet title={"Вход в Клуб"} />
            <h1 className="auth-page__h1">Вход в Клуб</h1>
            <div className="page__inner">
                <div className="container">
                    <form
                        onSubmit={handleSubmit(onSubmit)}
                        className="form-auth"
                    >
                        <div className="form-auth__field form-auth__field_telegram">
                            <label>Телеграм-логин</label>
                            <input
                                ref={register}
                                type="text"
                                name="telegram"
                                className="form-auth__input"
                            />
                        </div>
                        <div className="form-auth__field">
                            <label>Пароль</label>
                            <input
                                ref={register}
                                type="password"
                                name="password"
                                className="form-auth__input"
                            />
                        </div>
                        <button
                            type="submit"
                            disabled={false}
                            className="form_auth__button"
                        >
                            Войти в Клуб
                    </button>
                    </form>
                    <p><small>Если забыли пароль, поможет <a href="https://t.me/keys_club_bot">@keys_club_bot</a></small></p>
                </div>
                <div className="container">
                    <p><small>Чтобы стать участником Клуба, нужно получить приглашение от одного из действующих участников.<br />Если вы не знаете никого из Клуба, скорее всего, вы зашли сюда по ошибке. Уходите. Уходите. Уходите.</small></p>
                </div>
            </div>
        </div>
    )
}

export default LoginRoute
